module.exports = "/_next/static/images/3a091a5b69d789777e509192d7c6e9e6-roxinho-basicos-flutuantes-lg@3x.png";